import styled from 'styled-components';
import Typography from 'Typography';
import { getShade, lightenDarkenColor } from 'utils';

export const CircularButtonContainer = styled.button`
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: rgba(0,0,0,0);
  border-width: 0px;
  border-style: solid;
  :hover {
    cursor: pointer;
  }
  :focus {
    outline:0;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border-radius: 100%;
  border-width: 0.15em;
  min-height: ${({ theme }): string => theme.styleContainer.heightButton};
  max-height: ${({ theme }): string => theme.styleContainer.heightButton};
  min-width: ${({ theme }): string => theme.styleContainer.heightButton};
  max-width: ${({ theme }): string => theme.styleContainer.heightButton};
  transition-duration: 0.5s;
  background-color: ${({ theme }): string => theme.colors.main};
  border-style: solid;
  border-color: ${({ theme }): string => theme.colors.main};
  box-shadow: ${({ theme }): string => theme.colors.circularButtonShadow};
  font-size: ${({ theme }): string => theme.styleContainer.defaultFontSize};
  ${CircularButtonContainer}:hover & {
    background-color: ${({ theme }): string => lightenDarkenColor(theme.colors.main, getShade(theme.colors.main))};
    border-color: ${({ theme }): string => lightenDarkenColor(theme.colors.main, getShade(theme.colors.main))};
    cursor: pointer;
  }
`;

export const LabelContainer = styled(Typography)`
  ${CircularButtonContainer}:hover & {
    color: ${({ theme }): string => theme.colors.mainHover};
    cursor: pointer;
  }
  transition-duration: 0.5s;
`;

export const FantomContainer = styled.div`
  min-width: 2em;
  max-width: 2em;
  width: 2em;
`;
